export default "__VITE_ASSET__IMdfFj6R__"